import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "region-dashboards-base-info__label" }
const _hoisted_2 = { class: "region-dashboards-base-info__value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tooltip = _resolveComponent("Tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["region-dashboards-base-info", { 'region-dashboards-base-info_loading': _ctx.isLoading }])
  }, [
    _createVNode(_component_Tooltip, { class: "region-dashboards-base-info__tooltip tooltip-component--mobile-big" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.baseInfoTooltip), 1)
      ]),
      _: 1
    }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getBaseRegionInfoLabels, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "region-dashboards-base-info__item",
        key: item.label
      }, [
        _createElementVNode("div", _hoisted_1, _toDisplayString(item.label) + ":", 1),
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.getValue(item.value)), 1)
      ]))
    }), 128))
  ], 2))
}